export function clearLocalStorageAndRedirectToLogin() {
	localStorage.clear();
	const origin = window.location.origin + '';
	const url = window.location.href + '';
	const ssoUrl = window.location.origin + '/sso';
	const originBase64 = Buffer.from(origin, 'utf8').toString('base64');
	const urlBase64 = Buffer.from(url, 'utf8').toString('base64');
	const ssoUrlBase64 = Buffer.from(ssoUrl, 'utf8').toString('base64');
	window.location.href = `${process.env.VUE_APP_APPS_URL}?url=${urlBase64}&origin=${originBase64}&ssoVerification=${ssoUrlBase64}`;
}